import { Component } from '@angular/core';
import { HeaderLatestComponent } from 'src/app/home/landing-root/header-latest/header-latest.component';
import { PeopleflowFooterComponent } from 'src/app/peopleflow-footer/peopleflow-footer.component';

@Component({
  selector: 'app-emp-managment-footer',
  imports: [HeaderLatestComponent , PeopleflowFooterComponent ],
  templateUrl: './emp-managment-footer.html',
  styleUrl: './emp-managment-footer.scss',
})
export class EmpManagmentFooter {

}
